
export default{
    isLogin:function(_this){
        if(!_this.$store.getters.getLoginValue){
            return _this.$router.push("Login")
        }
    },
    // 多语言字段：name 用逗号 / flag 用 |
    // 新格式（日英西）：日本語,English,Español
    // 旧格式兼容（4段）：中文,English,日本語,Español
    pickLangText:function(source, sep, lang){
        if (!source) return ''
        const lanng = lang || localStorage.getItem("lang") || 'en'
        const parts = String(source).split(sep || ',').map(function (s) { return (s || '').trim() })
        const at = function (i) { return parts[i] || '' }
        const first = function () {
            for (var i = 0; i < parts.length; i++) {
                if (parts[i]) return parts[i]
            }
            return String(source)
        }
        var ja, en, es
        if (parts.length >= 4) {
            // 旧：中,英,日,西
            ja = at(2); en = at(1); es = at(3)
        } else {
            // 新：日,英,西
            ja = at(0); en = at(1); es = at(2)
        }
        if (lanng === 'en') return en || ja || first()
        if (lanng === 'es') return es || en || ja || first()
        return ja || en || first()
    },    // 投注结果文案：rose/lily/balloon/fireworks
    lotteryLabel:function(type){
        // rose/lily/balloon/fireworks — 由调用方传入 i18n 文本或在组件内用 this.$t
        const lang = localStorage.getItem("lang") || 'en'
        const map = {
            ja: { rose: 'ロケット', lily: 'ハート', balloon: 'バラ', fireworks: 'ヨット' },
            en: { rose: 'Rose', lily: 'Lily', balloon: 'Balloon', fireworks: 'Fireworks' },
            es: { rose: 'Rosa', lily: 'Lirio', balloon: 'Globo', fireworks: 'Fuegos artificiales' },
        }
        const pack = map[lang] || map.ja
        return pack[type] || ''
    }
}

